module.exports = __webpack_public_path__ + "img/flomskredaktsomhet.abcf0b08.jpg";